import request from './AxiosRequest';

// includes firms but not sharefile or referral groups
const browseAll = () =>
    request({
        method: 'GET',
        url: '/Services/api/usergroup/getAllGroupsAndFirm',
        cancel: true
    });

// inclueds sharefile and referral groups but not firms
const browseAllGroups = () =>
    request({
        method: 'GET',
        url: '/Services/Api/UserGroup/GetAll',
        cancel: true
    });

const joinToGroup = data =>
    request({
        url: `/Services/Api/UserGroup`,
        method: 'POST',
        data,
        cancel: true
    });

const groupInfo = uniquename =>
    request({
        method: 'GET',
        url: `/Services/Api/groups?uniquename=${uniquename}`,
        cancel: true
    });

const GroupsAndFirms = {
    browseAll,
    browseAllGroups,
    joinToGroup,
    groupInfo
};

export default GroupsAndFirms;
